module.exports = __webpack_public_path__ + "img/Cyprus.6ce553ee.svg";